import { Pages } from 'modules/navigation/domain/enums/pages';
import { TourneyEncoded } from 'modules/tournaments/domain/interfaces/tourney-encoded';
import React, { useCallback, useEffect, useMemo } from 'react';
import UDBreadcrumbs from 'ud-ui/components/breadcrumbs';
import { useMainLayout } from 'ud-ui/layout/main/context';
import TourneyComponentsCreateForm from '../../components/create-form';

const TourneyPagesCreatePage = () => {
  const onSave = useCallback((_: Partial<TourneyEncoded>) => {}, []);
  const { setHeaderContent } = useMainLayout();

  const breadcrumbsItems = useMemo(() => {
    return [
      {
        label: 'Создание турнира',
        to: Pages.TOURNEYS.CREATE,
      },
    ];
  }, []);

  const breadcrumbs = useMemo(() => <UDBreadcrumbs className="my-10" breadcrumbs={breadcrumbsItems} />, [breadcrumbsItems]);

  useEffect(() => {
    setHeaderContent(breadcrumbs);

    return () => {
      setHeaderContent(null);
    };
  }, [breadcrumbs, setHeaderContent]);

  return <TourneyComponentsCreateForm onSubmit={onSave} />;
};

export default TourneyPagesCreatePage;
